import throttle from 'lodash.throttle';

import { ACTION_COMPLETED_LOCAL_REP, onFinishMultiAction } from '../Widget/actions';
import {
    completeRadialSlider,
    reanswerRadialSlider
} from '../../utils/radialSlider/radialSliderApi';

const submitAnswer = (apiRequestData, actionCompletedTime, value, answerId = null) => {
    if (answerId) {
        return reanswerRadialSlider(apiRequestData, actionCompletedTime, value, answerId);
    } else {
        return completeRadialSlider(apiRequestData, actionCompletedTime, value);
    }
};

const throttledSubmitAnswer = throttle(submitAnswer, 500, {
    leading: true,
    trailing: false
});

export const RADIAL_SLIDER_ANSWER_SUBMITTING = 'RADIAL_SLIDER_ANSWER_SUBMITTING';
export const RADIAL_SLIDER_ANSWERED = 'RADIAL_SLIDER_ANSWERED';
export const RADIAL_SLIDER_INITIATED = 'RADIAL_SLIDER_INITIATED';
export const RADIAL_SLIDER_SUCCESS = 'RADIAL_SLIDER_SUCCESS';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';

let redirected = false;

export const onInteractWithSlider = (actionInitiated, actionIdentifier) => dispatch => {
    if (!actionInitiated) {
        dispatch({ type: RADIAL_SLIDER_INITIATED, payload: actionIdentifier });
    }
};

export const onRadialSliderAnswered = (
    apiRequestData,
    actionIdentifier,
    actionCompletedTime,
    value,
    answerId,
    isAnswered,
    isMultiActionCard,
    isNewAnswerDifferent
) => dispatch => {
    if (answerId && !isNewAnswerDifferent) return;
    dispatch({
        type: RADIAL_SLIDER_ANSWER_SUBMITTING,
        payload: { isSubmitting: true, userAnswer: value }
    });
    const request = isAnswered
        ? throttledSubmitAnswer(apiRequestData, actionCompletedTime, value, answerId)
        : throttledSubmitAnswer(apiRequestData, actionCompletedTime, value);

    request.then(data => {
        dispatch({
            type: RADIAL_SLIDER_ANSWER_SUBMITTING,
            payload: { isSubmitting: false, userAnswer: value }
        });
        dispatch({ type: RADIAL_SLIDER_SUCCESS, payload: { data } });
    });

    dispatch({
        type: ACTION_COMPLETED_LOCAL_REP,
        payload: actionIdentifier
    });

    if (isMultiActionCard && !redirected) {
        redirected = true;
        setTimeout(() => {
            onFinishMultiAction(actionIdentifier)(dispatch);
        }, 5000);
    }
};
